import React from 'react'
import AppHeader from './AppHeader/AppHeaderContainer'
import AppMenu from './AppMenu/AppMenuContainer'
import AppHome from './AppHome/AppHome'

import '../css/index.css'

const App = () => (
    <div className='app-container'>
      <AppHeader />
      <AppMenu />
      <AppHome />
    </div>
)
export default App


// WEBPACK FOOTER //
// ./src/components/App.js